// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"482e09e0","453":"5ec6adf2","553":"b3151a80"}[chunkId] + ".chunk.js";
};